<template>
  <div class="app">
    <AppHeader fixed>
      <!-- <SidebarToggler 
        class="d-lg-none" 
        display="md" 
        mobile /> -->
      <b-link 
        class="navbar-brand" 
        :to="{ name: 'Dashboard' }">
        <img 
          class="navbar-brand-full" 
          src="img/ccpl_logo.png" 
          width="89" 
          height="25" 
          alt="CCPL Logo">
      </b-link>
      <!-- <SidebarToggler 
        class="d-md-down-none" 
        display="lg" /> -->
      <b-navbar-nav class="d-md-down-none">
        <b-nav-item v-if="$hasRole(serviceModule, 'Admin')" :to="{name: 'Reservations'}">
          Reservations
        </b-nav-item>
        <b-nav-item v-if="$hasRole(serviceModule, 'Ops-cleaning')" :to="{name: 'Cleaning'}">
          Cleaning
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto mr-4">
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <!-- <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :nav-items="navs"/>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar> -->
      <main class="main">
        <!-- <Breadcrumb :list="list"/> -->
        <div class="container-fluid mt-3">
          <router-view/>
        </div>
      </main>
      <!-- <AppAside fixed> -->
        <!--aside-->
        <!-- <DefaultAside/> -->
      <!-- </AppAside> -->
    </div>
    <NavigationFooter v-if="$mq === 'sm'" />
    <TheFooter>
      <!--footer-->
      <div>
        <span>&copy; {{ year }} Carclub Pte Ltd.</span>
        <span class="d-md-down-none">&nbsp;|&nbsp;{{ appVersion }}</span>
      </div>
      <div class="ml-auto">
        <span v-text="currentTime"/>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import NavigationFooter from '@/components/NavigationFooter'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import moment from 'moment'
import { server, auth } from '@/services/'

export default {
  name: 'Full',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    NavigationFooter
  },
  data () {
    return {
      serviceModule: 'VMTS Toyota PH',
      currentTime: null,
      navs: [],
      user: null,
      year: moment().year(),
      appVersion: `v${process.env.VUE_APP_VERSION}`
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    },
    isAdminCleaning () {
      return auth.hasRole('CLEANING', 'admin')
    }
  },
  created () {
    this.currentTime = moment().format('HH:mm:ss');
    setInterval(() => this.updateCurrentTime(), 1 * 1000);
    this.user = auth.getUser()
    // this.navs = auth.getNavs()
  },
  methods: {
    updateCurrentTime() {
      this.currentTime = moment().format('YYYY-MM-DD | HH:mm:ss');
    },
    openSettings () {
      server.get('/ops/getGenerics').then(
        resp => {
          this.$modal.show(SettingsModal, {model: resp.data.msgContent.data[0]}, {height: 'auto', scrollable: true});
        }
      )

    }
  },
}
</script>
<style lang="scss" scoped>
.nav-link {
  padding-left: .5rem;
  padding-right: .5rem;
  &.active {
    border-bottom: 1px solid #4da748;
  }
}
</style>